import { render } from "./ThePants.vue?vue&type=template&id=479b67d6&scoped=true"
import script from "./ThePants.vue?vue&type=script&lang=js"
export * from "./ThePants.vue?vue&type=script&lang=js"

import "./ThePants.vue?vue&type=style&index=0&id=479b67d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479b67d6"]])

export default __exports__